import * as React from 'react';
import Select from 'react-select';
import styled from 'styled-components';

import { constants } from '../../constants';

const StyledSelect = styled(Select)`
    .css-2o5izw:hover {
        border: none;
    }
    .css-2o5izw {
        box-shadow: 0 0 0 1px ${constants.color.primary};
        border: none;
        background-color: ${constants.color.grey5};
        }
    .css-1aya2g8 {
        background-color: ${constants.color.grey5};
        border: none;
        display: flex;
        flex: 1;
    }

    .css-wqgs6e {
        background-color: ${constants.color.grey5};
    }
    .css-z5z6cw{
        background-color: ${constants.color.primary};
    }
` 

const SelectField = ({style, children, ...rest }) => (
    <StyledSelect style={style} {...rest}>
            {children}
    </StyledSelect>
);

export default SelectField;





// WEBPACK FOOTER //
// ./src/js/components/SelectField/SelectField.jsx